<script setup lang="ts">
import { faStar as faFilledStar } from '@fortawesome/pro-solid-svg-icons';
import { faStar as faEmptyStar } from '@fortawesome/pro-light-svg-icons';

defineProps<{
    label?: string;
    description?: string;
    compactLabel?: string;
    alignment?: 'center' | 'right';
}>();

const model = defineModel<number>({ default: 0 });
const hovered = ref(0);
const starMap = computed(() => {
    const max = Math.max(hovered.value, model.value, 0);
    return Array(5)
        .fill(faEmptyStar)
        .map((_, index) => (index + 1 > max ? faEmptyStar : faFilledStar));
});
</script>
<template>
    <mr-typography v-if="label" :align="alignment">
        {{ label }}
    </mr-typography>
    <mr-input-container
        :description
        ghost
        :label="compactLabel"
        :hide-description="!description"
    >
        <div class="rating-root">
            <div class="rating-container" @mouseout="hovered = 0">
                <mr-icon
                    v-for="index in 5"
                    :key="index"
                    :icon="starMap[index - 1]"
                    color="var(--yellow-400)"
                    primary-color="var(--yellow-200)"
                    secondary-color="var(--yellow-400)"
                    class="clickable"
                    @mouseover="hovered = index"
                    @mouseout.prevent.stop
                    @click="model = index"
                />
            </div>
        </div>
    </mr-input-container>
</template>
<style scoped lang="scss">
.rating-root {
    display: flex;
    width: 100%;
    .rating-container {
        display: flex;
        width: 100%;
        justify-content: v-bind(alignment);
        gap: 12px;
        padding: 8px;
        .clickable {
            cursor: pointer;
        }
    }
}
</style>
